export const IconUserCheck = (props: { size?: number; color?: string }) => {
	const width: number = props.size ?? 24;
	const color: string = props.color ?? "#14171F";
	return (
		<svg width={width} height={width} viewBox={`0 -960 960 960`} fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill={color}
				fillOpacity="0.6"
				d="M702-494.23 574.23-622 617-663.77l85 85 170-170L914.15-706 702-494.23Zm-342 1.92q-57.92 0-98.96-41.04Q220-574.38 220-632.31q0-57.92 41.04-98.96 41.04-41.04 98.96-41.04 57.92 0 98.96 41.04Q500-690.23 500-632.31q0 57.93-41.04 98.96-41.04 41.04-98.96 41.04ZM60-187.69v-88.93q0-29.38 15.96-54.42 15.96-25.04 42.66-38.5 59.3-29.07 119.65-43.61 60.35-14.54 121.73-14.54t121.73 14.54q60.35 14.54 119.65 43.61 26.7 13.46 42.66 38.5Q660-306 660-276.62v88.93H60Z"
			/>
		</svg>
	);
};
